import React, { useState } from "react";
import styles from "./EmployeesTab.module.css";

const emptyForm = {
  fullName: "", jobTitle: "", phone: "", baseSalary: "",
  commissionRate: "", isActive: true, hireDate: "", notes: "",
};

const EmployeeFormModal = ({ initialData, onSubmit, onClose }) => {
  const [form, setForm] = useState(
    initialData ? { ...initialData, hireDate: initialData.hireDate?.slice(0, 10) } : emptyForm
  );
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await onSubmit({
        ...form,
        baseSalary: Number(form.baseSalary),
        commissionRate: Number(form.commissionRate),
        hireDate: new Date(form.hireDate).toISOString(),
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <form className={styles.modal} onClick={(e) => e.stopPropagation()} onSubmit={handleSubmit}>
        <h3>{initialData ? "تعديل بيانات موظف" : "إضافة موظف جديد"}</h3>

        <div className={styles.formGrid}>
          <label>الاسم الكامل
            <input name="fullName" value={form.fullName} onChange={handleChange} required />
          </label>
          <label>الوظيفة
            <input name="jobTitle" value={form.jobTitle} onChange={handleChange} required />
          </label>
          <label>رقم الهاتف
            <input name="phone" value={form.phone} onChange={handleChange} required />
          </label>
          <label>الراتب الأساسي
            <input type="number" name="baseSalary" value={form.baseSalary} onChange={handleChange} required min="0" />
          </label>
          <label>نسبة العمولة (%)
            <input type="number" name="commissionRate" value={form.commissionRate} onChange={handleChange} min="0" max="100" />
          </label>
          <label>تاريخ التعيين
            <input type="date" name="hireDate" value={form.hireDate} onChange={handleChange} required />
          </label>
          <label className={styles.fullWidth}>ملاحظات
            <textarea name="notes" value={form.notes} onChange={handleChange} rows={2} />
          </label>
          <label className={styles.checkboxLabel}>
            <input type="checkbox" name="isActive" checked={form.isActive} onChange={handleChange} />
            موظف نشط
          </label>
        </div>

        <div className={styles.actions}>
          <button type="button" className={styles.cancelBtn} onClick={onClose} disabled={submitting}>إلغاء</button>
          <button type="submit" className={styles.confirmBtn} disabled={submitting}>
            {submitting ? "جاري الحفظ..." : "حفظ"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EmployeeFormModal;